import Api from './Api'
import {store} from '../store/index'

function getOrgId() {
  return store.getters['user/getOrgContext'] || store.getters['user/getOrgId']
}

export default {
  async getOrgContacts() {
    return new Api().get('/admin/api/v1/orgs/' + getOrgId() + '/org_contacts?deleted=false')
  },
  async insertOrgContact(orgContact) {
    return new Api().put('/admin/api/v1/orgs/' + getOrgId() + '/org_contacts' , orgContact)
  },
  async updateOrgContact(orgContact, patchObject) {
    return new Api().patch(`/admin/api/v1/orgs/${getOrgId()}/org_contacts/${orgContact.id}`, patchObject)
  },
  async deleteOrgContact(orgContact) {
    return new Api().delete(`/admin/api/v1/orgs/${getOrgId()}/org_contacts/${orgContact.id}`)
  }
}